module.exports = __webpack_public_path__ + "img/logo_txtwhite_bggreen.14fb40a2.jpg";